import { render, staticRenderFns } from "./galleryBox.vue?vue&type=template&id=450fdeda&scoped=true"
import script from "./galleryBox.vue?vue&type=script&lang=js"
export * from "./galleryBox.vue?vue&type=script&lang=js"
import style0 from "./galleryBox.vue?vue&type=style&index=0&id=450fdeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450fdeda",
  null
  
)

export default component.exports